const Blockly = require('blockly');
const mdcConfig = require('@sstdev/lib_metadata-config');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const { config } = mdcConfig;

const TOOLTIP = 'Add some text to the menu';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    const workspace = blocklyBlock.workspace;
    const blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);

    line1OfInputs.appendField('  Icon Name:').appendField(new Blockly.FieldTextInput(''), 'iconName');
    line1OfInputs.appendField('  Text:').appendField(new Blockly.FieldTextInput(), 'title');

    const line2OfInput = blocklyBlock.appendDummyInput().setAlign(Blockly.ALIGN_RIGHT);
    const sizeDropDown = new Blockly.FieldDropdown(config.textSizes);
    sizeDropDown.setValue('sm');
    const weightDropDown = new Blockly.FieldDropdown(config.textStyles);
    weightDropDown.setValue('regular');

    line2OfInput.appendField('  Text Size:').appendField(sizeDropDown, 'textSize');
    line2OfInput.appendField('  Text Weight:').appendField(weightDropDown, 'textWeight');
}
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['iconName', 'title', 'textSize', 'textWeight']);
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
